import React, { useState } from "react";
import { FiDownload, FiFileText, FiUsers, FiAward, FiCheckCircle, FiTrendingUp } from "react-icons/fi";
import "../../styles/challenges.css";

export default function GSIDAwards() {
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    university: "",
    category: "phd",
    title: "",
    abstractFile: null,
  });

  const members = [
    {
      id: 1,
      image: "https://via.placeholder.com/150?text=Member+1",
      nom: "Dupont",
      prenom: "Jean",
      domaine: "Cybersécurité"
    },
    {
      id: 2,
      image: "https://via.placeholder.com/150?text=Member+2",
      nom: "Martin",
      prenom: "Sophie",
      domaine: "Intelligence Artificielle"
    },
    {
      id: 3,
      image: "https://via.placeholder.com/150?text=Member+3",
      nom: "Ahmed",
      prenom: "Karim",
      domaine: "Sécurité des Données"
    },
    {
      id: 4,
      image: "https://via.placeholder.com/150?text=Member+4",
      nom: "Benali",
      prenom: "Fatima",
      domaine: "Innovation Technologique"
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({ ...prev, abstractFile: e.target.files[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you for registering! We will contact you soon.");
    setFormData({
      fullName: "",
      email: "",
      phone: "",
      university: "",
      category: "phd",
      title: "",
      abstractFile: null,
    });
    setShowRegistrationForm(false);
  };

  return (
    <div className="challenges-container">
      {/* Hero Section */}
      <section className="challenge-hero">
        <div className="challenge-hero-content">
          <h1>GSIDA ACADEMIC CHALLENGE 2026</h1>
          <p className="challenge-subtitle">YOUNG PEOPLE AND STUDENTS</p>
          <div className="challenge-tagline">
            <span className="tagline-item">EXCELLENCE</span>
            <span className="tagline-divider">–</span>
            <span className="tagline-item">INNOVATION</span>
            <span className="tagline-divider">–</span>
            <span className="tagline-item">COLLABORATION</span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="challenge-content">
        <div className="content-wrapper">
          {/* Competition Objective */}
          <div className="challenge-section">
            <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Competition Objective</h3>
          </div>
            <p>
              The GSIDA Academic Challenge aims to stimulate scientific excellence among young people and students, 
              creativity and the dissemination of knowledge through interdisciplinary and collaborative activities.
            </p>
          </div>

          {/* Participation Categories */}
          <div className="challenge-section">
            <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Participation Categories</h3>
          </div>
            <div className="category-box">
              <FiUsers className="section-icon" />
              <div>
                <h3>PhD Students</h3>
                <p>Individual or paired interventions.</p>
              </div>
            </div>
          </div>

          {/* Evaluation Criteria */}
          <div className="challenge-section">
            
            <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Evaluation Criteria <span className="points">(100 points)</span></h3>
          </div>
            <div className="criteria-grid">
              <div className="criteria-card">
                <h4>Scientific Quality</h4>
                <p className="points-value">40 points</p>
                <p className="criteria-description">Rigor and innovation in research methodology</p>
              </div>
              <div className="criteria-card">
                <h4>Clarity, Pedagogy & Timing</h4>
                <p className="points-value">30 points</p>
                <p className="criteria-description">Clear presentation and respect for timing constraints</p>
              </div>
              <div className="criteria-card">
                <h4>Communication & Engagement</h4>
                <p className="points-value">30 points</p>
                <p className="criteria-description">Social media presence (Facebook, Instagram, LinkedIn)</p>
              </div>
            </div>
          </div>

          {/* Awards */}
          <div className="challenge-section awards-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Awards Given</h3>
            </div>
            <div className="awards-list">
              <div className="award-item">
                <div className="award-icon">
                  <FiAward className="award-image" />
                </div>
                <p><strong>GSIDA Trophy 2026</strong></p>
              </div>
              <div className="award-item">
                <div className="award-icon">
                  <FiCheckCircle className="award-image" />
                </div>
                <p><strong>Official Certificate</strong> for each winning member</p>
              </div>
              <div className="award-item">
                <div className="award-icon">
                  <FiTrendingUp className="award-image" />
                </div>
                <p><strong>Featured on website</strong> and GSIDA press release</p>
              </div>
            </div>
          </div>

          {/* Competition Spirit */}
          <div className="challenge-section spirit-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Competitive Spirit</h3>
            </div>
            <div className="spirit-box">
              <p>
                A fair competition, based on sharing, ethics, and scientific collaboration. 
                Any form of plagiarism or unethical behavior will result in immediate disqualification.
              </p>
              <p className="hashtag">#GSIDA2026 – Together for academic innovation!</p>
            </div>
          </div>

          {/* Members Section */}
          <div className="challenge-section members-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Competition Members</h3>
            </div>
            <div className="members-grid">
              {members.map((member) => (
                <div className="member-card" key={member.id}>
                  <img src={member.image} alt={`${member.prenom} ${member.nom}`} className="member-image" />
                  <div className="member-info">
                    <h4>{member.prenom} {member.nom}</h4>
                    <p className="member-domain">{member.domaine}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Agadir Summit Section */}
             <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3  >Agadir Private Security & Innovation Summit</h3>
            </div>
          <div className="challenge-section summit-section">
         
            <p className="summit-description1" style={{color:"white"}}>
              Connect with industry leaders and innovators. This exclusive summit brings together 
              the brightest minds in security and innovation for networking and knowledge sharing.
            </p>
            
            <div className="summit-actions">
              <a href="/pdfs/summit-agenda.pdf" className="action-button pdf-button">
                <FiDownload /> Download Program (A4 PDF)
              </a>
              <button 
                className="action-button register-button"
                onClick={() => setShowRegistrationForm(!showRegistrationForm)}
              >
                <FiFileText /> Register Now
              </button>
            </div>
          </div>

          {/* Registration Form */}
          {showRegistrationForm && (
            <div className="registration-form-section">
              <div className="section-header-v2">
                <span className="accent-line"></span>
                <h3>Registration Form</h3>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone *</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>University/Institution *</label>
                  <input
                    type="text"
                    name="university"
                    value={formData.university}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Category *</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                  >
                    <option value="phd">PhD Student</option>
                    <option value="masters">Master Student</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Research Title *</label>
                  <input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Abstract/CV File</label>
                  <input
                    type="file"
                    name="abstractFile"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                  />
                </div>

                <div className="form-actions">
                  <button type="submit" className="submit-btn">Submit Registration</button>
                  <button 
                    type="button" 
                    className="cancel-btn"
                    onClick={() => setShowRegistrationForm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
